<template>
  <collapsible-section title="PIM_PRODUCT-ACCORDION_TITLE-ATTRIBUTES" :defaultOpen="defaultOpen">

    <!-- isDrug -->
    <template v-if="pharmacy === null">
      <div class="control">
        <div class="control-label">
          <label-name labelKey="PIM-PRODUCT-IS_DRUG"></label-name>
        </div>
        <div class="control">
          <b-switch
            v-model.sync="product.isDrug"
            type="primary"
            size="small"
          ></b-switch>
        </div>
      </div>
      
      <!-- Dietary Properties (Placeholders) -->
      <div class="control" style="margin-top: 12px; margin-bottom: 12px;">
        <div class="control-label">
          <label-name labelKey="PIM-PRODUCT-DIETARY_PROPERTIES"></label-name>
        </div>
        <div style="display: flex; gap: 24px; margin-top: 6px; flex-wrap: wrap;">
          <b-switch v-model.sync="product.glutenFree" type="primary" size="small"><lang labelKey="PIM-PRODUCT-GLUTEN_FREE"></lang></b-switch>
          <b-switch v-model.sync="product.lactoseFree" type="primary" size="small"><lang labelKey="PIM-PRODUCT-LACTOSE_FREE"></lang></b-switch>
          <b-switch v-model.sync="product.sugarFree" type="primary" size="small"><lang labelKey="PIM-PRODUCT-SUGAR_FREE"></lang></b-switch>
          <b-switch v-model.sync="product.vegan" type="primary" size="small"><lang labelKey="PIM-PRODUCT-VEGAN"></lang></b-switch>
        </div>
      </div>
    </template>

    <!-- attributes -->
    <form-input
      v-for="(value, key) in (pharmacy === null && typeof product.attributes === 'object' ? product.attributes : {})"
      inputType="text"
      :label="'PIM-PRODUCT-ATTRIBUTE-' + key + labelSuffix"
      v-model="product.attributes[key]"
      :isReadOnly="key != 'color' && key != 'flavor' && isReadonly"
      :isPointToComma="true"
      v-bind:key="key"
    ></form-input>

    <!-- dosageForm -->
    <form-input
      inputType="select"
      :showLabelInOptions="false"
      :label="'PIM-PRODUCT-DOSAGE_FORM' + labelSuffix"
      :selectIsSearchable="true"
      v-model="dosageFormWrapper"
      :selectOptions="dosageFormsOptions"
    ></form-input>

    <!-- leaflet URL -->
    <template v-if="pharmacy == null && product.packageLeafletUrl">
      <div class="control" style="margin: 20px 0;">
        <div class="control-label">
          <label-name
            labelKey="PIM-PRODUCT-PACKAGE_LEAFLET_URL"
          ></label-name>
        </div>
        <div class="control" style="display: flex; flex-direction: row;">
          <span class="icon is-small">
            <i class="icon-ak-datei-pdf"></i>
          </span>
          <span>
            <a :href="product.packageLeafletUrl" download>
              <lang
                labelKey="PIM-PRODUCT-PACKAGE_LEAFLET_DOWNLOAD_URL"
              ></lang>
            </a>
          </span>
        </div>
      </div>
    </template>

    <!-- packaging sizes -->
    <form-input
      inputType="text"
      label="PIM-PRODUCT-PACKAGING_SIZE-PIM"
      v-model="product.packagingSizes.pim"
      v-if="product.packagingSizes.pim != null"
      :isPointToComma="true"
    ></form-input>

    <ul class="otherValuesContainer" v-if="filteredPackagingSizes.length > 0">
      <li
        v-for="key in filteredPackagingSizes"
        :key="key"
        class="otherValues"
      >
        <span class="key">
          <lang
            :labelKey="
              'PIM-PRODUCT-PACKAGING_SIZE-' + key + labelSuffix
            "
          ></lang
          >: </span
        ><br />
        <span class="value">{{ filteredPackagingSizes[key] }}</span
        ><br />
      </li>
    </ul>

    <!-- tags -->
    <form-input
      inputType="text"
      :label="'PIM-PRODUCT-TAGS' + labelSuffix"
      v-model="product.tags"
    ></form-input>

  </collapsible-section>
</template>

<script>
import CollapsibleSection from "../../utils/CollapsibleSection.vue";

export default {
  name: "ProductSectionAttributes",

  components: {
    CollapsibleSection,
  },

  props: {
    product: { type: Object, required: true },
    pharmacy: { type: Object, default: null },
    isReadonly: { type: Boolean, default: false },
    labelSuffix: { type: String, default: "" },
    defaultOpen: { type: Boolean, default: false },
    dosageForms: { type: [Array, Object], default: () => [] },
  },

  computed: {

    filteredPackagingSizes() {
      return Object.fromEntries(
        Object.entries(this.product.packagingSizes).filter(([key, value]) => key !== 'pim' && value !== null)
      );
    },

    dosageFormsOptions() {
      let arr = [];
      for (let key in this.dosageForms) {
        arr.push({
          id: key,
          name: this.dosageForms[key],
        });
      }
      return arr;
    },

    dosageFormWrapper: {
      get() {
        return this.product.dosageForm == null
          ? null
          : this.dosageFormsOptions.find(
              (_) => _.id == this.product.dosageForm
            );
      },
      set(value) {
        this.product.dosageForm = value != null ? value.id : null;
      },
    },

 
  },

  created() {

  }
};
</script>


<style scoped lang="scss">
.otherValuesContainer {
  padding-left: 10px;
  margin: 0 0 40px 0;
  display: block;
  border: none;

  li.otherValues {
    background: #f0f1f2;
    border-radius: 3px;
    margin-bottom: 3px;
    padding: 2px 5px;
    white-space: normal;

    .key {
      display: inline-block;
      font-weight: 400;
      overflow: hidden;
      margin-right: 8px;
      font-size: 11px;
      text-transform: uppercase;
    }

    .value {
      font-size: 11px !important;
      width: 440px;

      p {
        padding-bottom: 10px;
      }
    }
  }
}
</style>

